import { useState } from "react";
import { Box } from "@mui/system";
import Grid from "@mui/material/Unstable_Grid2";
import { Typography } from "@mui/material";
import "./ContactSupport.scss";

const CONTACTSUPPORT = () => {
  const [steps, setSteps] = useState([
    {
      id: 1,
      step: "Step 1",
      desc: "To contact us via email, please click on the following link: emailLink. Once you click on the link, it will open your default email client, where you can compose a new message to us. Please provide as much detail as possible in your email, including your session name, any virtual machine URLs, used AMI name, and a brief description of your issue.",
    },
    {
      id: 2,
      step: "Step 2",
      desc: "You will receive an acknowledgment by e-mail with the ticket ID.",
    },
    {
      id: 3,
      step: "Step 3",
      desc: "You will get the ticket status by email when your ticket is assigned to the support team member.",
    },
    {
      id: 4,
      step: "Step 4",
      desc: "Support will return based on expected time of arrival and ticket priority.",
    },
  ]);
  const sendEmail = () => {
    window.open(
      `mailto:support@mail-acc.com?subject= EPC001 Live Training - Epic Games Support&cc=ashwin.ujjainkar@acc.ltd;shubham.patil@acc.ltd;adwait.rane@acc.ltd`
    );
  };
  const stepGenrator = (steps) => {
    return steps.map((step) => {
      if (step.id === 1) {
        let [beforeLinkText, afterLinkText] = step.desc.split("emailLink");
        return (
          <div className="stepGenrator" key={step.id}>
            <p className="larger_f_bold step">{step.step}:</p>
            <p className="step_desc">
              {beforeLinkText}
              <span onClick={() => sendEmail()} className="link">
                email us
              </span>
              {afterLinkText}
            </p>
          </div>
        );
      }
      return (
        <div className="stepGenrator" key={step.id}>
          <p className="larger_f_bold step">{step.step}:</p>
          <p className="step_desc">{step.desc}</p>
        </div>
      );
    });
  };
  return (
    <>
      <span className="larger_f_bold marginSets">Contact & Support</span>
      <div className="ContactSupport d-flex flex-column justify-content-center w-100 h-100 container">
        <Grid container spacing={2} alignItems="flex-start">
          {/* <div> */}
          <Grid className="grid-item" item xs={12} md={6}>
            <Grid className="grid-item-1" item xs={12} md={12}>
              <Typography className="larger_f_bold grid-item-text">
                Contact Us :
              </Typography>

              <p className="sub-text">
                We welcome your feedback, comments, and questions.
              </p>
              <p className="sub-text">You can reach us by email, phone.</p>
              <div>
                <p>
                  Email:
                  <span className="larger_f_bold grid-item-sub-text">
                    support@mail-acc.com
                  </span>
                </p>
                <p>
                  Phone:
                  <span className="larger_f_bold grid-item-sub-text">
                    +91 80690 39016
                  </span>
                </p>
              </div>
              <p className="sub-text">
                We're here to help you 24/7.
                <br />
                You can contact us by phone or email at any time, and we'll be
                happy to assist you with any questions or concerns you may have.
              </p>
            </Grid>

            <Grid className="grid-item-3" item xs={12} md={12}>
              <Typography className="larger_f_bold grid-item-text">
                Support ticket priority and ETA :
              </Typography>
              <p className="sub-text">
                Our ticket will be addressed according to its priority level.
              </p>
              <p className="sub-text">
                For P1 tickets, which are critical issues that impact the
                production system, our team will respond within 15mins and
                resolve within 4Hrs.
              </p>
              <p className="sub-text">
                For P2 tickets, which are urgent issues that affect the system's
                functionality, our team will respond within 30 mins and resolve
                within 48 Hrs.
              </p>
              <p className="sub-text">
                For P3 tickets, which are general issues or inquiries, our team
                will respond within 30 mins and resolve within 72Hrs.
              </p>
            </Grid>
          </Grid>
          <Grid className="grid-item-2" item xs={12} md={6} height={"100%"}>
            <div className="rightContainer">
              <Typography className="larger_f_bold grid-item-text">
                How to Raise a Ticket
              </Typography>
              <p className="sub-text">
                If you need assistance with a product or service, the fastest
                way to get help is to raise a ticket with our support team.
                Follow these steps to raise a ticket:
              </p>
              {stepGenrator(steps)}
              <p className="sub-text">
                Thank you for choosing our products and services, and we look
                forward to assisting you soon.
              </p>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
export default CONTACTSUPPORT;
